import React, { useState, useEffect } from "react";
import { HashLoader } from "react-spinners";

export default function Loader() {
  const [loaderColor, setLoaderColor] = useState(
    getComputedStyle(document.documentElement).getPropertyValue("--color-primary")?.trim() || "#ff3030"
  );

  // Listen for theme (CSS variable) changes
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const color = getComputedStyle(document.documentElement)
        .getPropertyValue("--color-primary")
        .trim();
      if (color && color !== loaderColor) {
        setLoaderColor(color);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["style"],
      subtree: false,
    });

    return () => observer.disconnect();
  }, [loaderColor]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-gray-900 z-50">
      <div className="flex flex-col items-center space-y-4 p-4">
        <HashLoader color={loaderColor} size={60} />
        <p className="text-gray-800 dark:text-gray-200 text-lg font-medium">
          Loading...
        </p>
      </div>
    </div>
  );
}
